import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { useCookieConsent } from "../context/CookieConsentContext";
import useApi from "../utils/useApi";
import Toaster from "../components/Toaster";
const Header = () => {
  const [menuActive, setMenuActive] = useState(false); // Track mobile menu state
  const [searchActive, setSearchActive] = useState(false); // Track search box state
 
  //search states
  const { callApi } = useApi();
const { user } = useAuth();
 
const [searchQuery, setSearchQuery] = useState("");
const [searchResults, setSearchResults] = useState([]);
const [isDropdownVisible, setDropdownVisible] = useState(false);
const [isSearching, setIsSearching] = useState(false);
//search states end
  
 
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { resetCookieConsent } = useCookieConsent();
  // Toggle mobile menu
  const handleMobileMenuToggle = () => {
    setMenuActive((prevState) => !prevState);
  };
 
  // Toggle search box
  const handleSearchToggle = () => {
    setSearchActive((prevState) => !prevState);
  };
 
  const handleLogout = () => {
    logout(); // Call logout function
    localStorage.removeItem("cookieAccepted"); // Clear cookie consent data from localStorage
    localStorage.removeItem("cookieAcceptedTimestamp");
    resetCookieConsent(); // Reset coockie consent state
    navigate("/signin"); // Redirect to Sign In page after logout
  };
 
  // ✅ Add/remove "menu_active" class on <body> when menuActive state changes
  useEffect(() => {
    if (menuActive) {
      document.body.classList.add("menu_active");
    } else {
      document.body.classList.remove("menu_active");
    }
  }, [menuActive]);
  // const actionSearchQuery = (query) => {
  //   // setCurrentPage(1);
  //   setSearchQuery(query);
  // };
 
    //search functionality start
    useEffect(() => {
      const delayDebounce = setTimeout(() => {
        if (searchQuery.length >= 2) {
          fetchSearchResults(searchQuery);
        } else {
          setSearchResults([]);
          setDropdownVisible(false);
        }
      }, 400); // debounce
    
      return () => clearTimeout(delayDebounce);
    }, [searchQuery]);
 
    const fetchSearchResults = async (keyword) => {
      setIsSearching(true);
      try {
        const isClient = user?.user_role?.toLowerCase() === "client";
        const endpoint = isClient
          ? "/client/shared-folders"
          : "/admin/directories/get-sub-directory";
    
        const response = await callApi({
          endpoint,
          params: {
            keyword,
            page: 1,
            length: 10,
          },
        });
    
        if (response?.success) {
          const foldersData = isClient
            ? response.data.sharedFolders || []
            : response.data.directories || [];
    
          setSearchResults(foldersData);
          setDropdownVisible(true);
        } else {
          setSearchResults([]);
          setDropdownVisible(false);
        }
      } catch (err) {
        console.error("Search error", err);
        Toaster.error("Search failed");
      } finally {
        setIsSearching(false);
      }
    };
    
    //search functionality ends
   console.log('user', user)
  
  
  
 
  return (
    <header className="header">
      <div className="container-fluid">
        <div className="header_inner">
          {/* Left: Logo */}
          <div className="header_left">
            <Link className="logo" to="/dashboard">
              <img src="/images/logo.png" alt="Logo" />
            </Link>
          </div>
 
          {/* Right: Mobile Menu Trigger + Search + Logout */}
          <div className="header_right d-flex">
            {/* Mobile Menu Trigger */}
            <div className="trigger_holder">
              <div
                className="trigger_mobile_menu"
                onClick={handleMobileMenuToggle}
              >
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div className="header_dsboard">
                <span>
                  <i className="fa-solid fa-house"></i>
                </span>
                Dashboard
              </div>
            </div>
 
            {/* Search Box */}
           
            <div className={`search_holder ${searchActive ? "active" : ""}`}>
            {user.user_role==='ADMIN' &&
              <div
                className={`search_inp_box ${searchActive ? "active" : ""}`}
                id="searchBox"
              >
                {/* <input
                type="search"
                placeholder="Search"
                /> */}
                <input
    type="search"
    placeholder="Search"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    onFocus={() => setDropdownVisible(true)}
    onBlur={() => setTimeout(() => setDropdownVisible(false), 150)} // allow click
  />
                <span id="searchIcon" onClick={handleSearchToggle}>
                  <i className="fa-solid fa-magnifying-glass"></i>
                </span>
 
                {/* new 2/7/25 start */}
                {isDropdownVisible && (
    <div className="search-dropdown">
      {isSearching ? (
        <div className="dropdown-item">Searching...</div>
      ) : searchResults.length === 0 ? (
        <div className="dropdown-item">No results</div>
      ) : (
        <ul>
          {searchResults.map((folder) => (
            <li key={folder.entity_id}>
              <Link to={`/folder-details/${folder.entity_id}`}>
                {folder.entity_name}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  )}
              </div>}
                {/* new 2/7/25 end */}
              {/* Logout */}
              <button className="log_out" onClick={handleLogout}>
                <span>
                  <i className="fa-solid fa-arrow-right-from-bracket"></i>
                </span>
                Log Out
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
 
export default Header;